<template>
  <a      
    @click="toggleLikeStatus"
    :href="loginUrlWithPassback"
    :class="likeButtonClass"
    >
      <span class="ba f4 pa2 br2 b--black-10 bg-animate hover-bg-near-white cursor">
        <span class="f3">&heartsuit;</span>
        <span class="silver">{{ likeCount }}</span>
      </span>
  </a>
</template>

<script>
import { mapState } from 'vuex';
import ProjectService from '../../../../api/ProjectService';
import EventBus from '../../../../api/EventBus';
import _ from 'lodash';
export default {
    name: 'ProProjectReactionForm',
    props: {
        projectId: {
            required: true,
            type: Number,
        },
        creatorId: {
            required: true,
            type: Number,
        },
    },
    computed: {
        ...mapState(['currentUser', 'env']),
        isAuthenticated: function() {
            return !_.isNil(this.currentUser.id);
        },
        loginUrlWithPassback: function() {
            const postLoginUrl = `/pro/profile/${this.creatorId}?projectId=${this.projectId}`;
            return `/login?postAuthRequestPath=${encodeURIComponent(postLoginUrl)}`;
        },
        likeButtonClass: function() {
            return this.isLikedByCurrentUser ? 'liked' : 'gray';
        },
    },
    data() {
        return {
            isLikedByCurrentUser: false,
            likeCount: 0,
            processingLikeToggle: false,
        };
    },
    created() {
        const p = this.isAuthenticated
            ? ProjectService.getProjectLikeInfoForUser(this.projectId, this.currentUser.id)
            : ProjectService.getProjectLikeInfo(this.projectId);
        p.then(({ data }) => {
            this.isLikedByCurrentUser = data.likedByUser;
            this.likeCount = data.likeCount;
        });

        EventBus.$on('reactedToProject', this.handleReactedToProjectEvent);
    },
    destroyed() {
        EventBus.$off('reactedToProject', this.handleReactedToProjectEvent);
    },

    methods: {
        toggleLikeStatus: function(e) {
            if(!this.processingLikeToggle) { //prevent double click
                if (!this.isAuthenticated) return;
                e.preventDefault();
                if (this.isLikedByCurrentUser) {
                    this.unlike();
                } else {
                    this.like();
                }
            } else {
                e.preventDefault();
            }

        },
        like: function() {
            this.processingLikeToggle = true;

            //optimistically set these values client side to avoid ui delay
            this.isLikedByCurrentUser = true;
            this.likeCount++;

            ProjectService.likeProject(this.projectId).then(() => {
                this.emitReactedToProjectEvent();
                this.processingLikeToggle = false;
            }).catch(err => {
                console.error(err);
                this.processingLikeToggle = false;
            });
        },
        unlike: function() {
            this.processingLikeToggle = true;

            //optimistically set these values client side to avoid ui delay
            this.isLikedByCurrentUser = false;
            this.likeCount--;

            ProjectService.unlikeProject(this.projectId).then(() => {
                this.emitReactedToProjectEvent();
                this.processingLikeToggle = false;
            }).catch(err => {
                console.error(err);
                this.processingLikeToggle = false;
            })
        },
        emitReactedToProjectEvent() {
            EventBus.$emit('reactedToProject', {
                projectId: this.projectId,
                isLikedByCurrentUser: this.isLikedByCurrentUser,
                likeCount: this.likeCount
            });
        },
        handleReactedToProjectEvent(reactionEvent) {
            if(this.projectId === reactionEvent.projectId) {
                this.isLikedByCurrentUser = reactionEvent.isLikedByCurrentUser;
                this.likeCount = reactionEvent.likeCount;
            }
        }
    },
};
</script>

<style scoped>

.gray:hover {
    color: #666;
}

.liked {
    color: #e62525 !important;
}

.liked:hover {
    color: #a92525;
}
</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/project/components/ProProjectReactionForm.vue